import type { ProsConsTone } from './styles'
import { CardBody, CardContainer, CardDesc, CardDescLine, CardIcon, CardTag } from './styles'

interface ProsConsCardProps {
  tone: ProsConsTone
  icon: string
  tag: string
  descLines: string[]
}

export function ProsConsCard({ tone, icon, tag, descLines }: ProsConsCardProps) {
  return (
    <CardContainer tone={tone}>
      <CardIcon
        src={icon}
        alt=''
        width={90}
        height={90}
        loading='lazy'
        decoding='async'
      />
      <CardBody>
        <CardTag tone={tone}>{tag}</CardTag>
        <CardDesc>
          {descLines.map((line) => (
            <CardDescLine key={line}>{line}</CardDescLine>
          ))}
        </CardDesc>
      </CardBody>
    </CardContainer>
  )
}
